import { types, actions } from './requests'
export const GETURGENTJOBLIST_TYPES = {
    ...types('GETURGENTJOBLIST'),
}
export const GETURGENTJOBLIST_ACTIONS = {
    ...actions('GETURGENTJOBLIST'),
}
